module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header -i navbar navbar-fixed-top"
  }, [_c('div', {
    staticClass: "page-header-inner"
  }, [_vm._m(0), _vm._v(" "), _c('LopeHorizontalMenu'), _vm._v(" "), _c('a', {
    staticClass: "menu-toggler responsive-toggler",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "top-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav pull-right"
  }, [_c('li', {
    staticClass: "dropdown dropdown-user"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown",
      "data-hover": "dropdown",
      "data-close-others": "true"
    }
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "alt": "",
      "src": require("../../assets/admin.png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "username username-hide-on-mobile"
  }, [_vm._v(_vm._s(_vm.username))])])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown dropdown-quick-sidebar-toggler"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.exit
    }
  }, [_c('i', {
    staticClass: "icon-logout"
  })])])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-logo"
  }, [_c('a', {
    attrs: {
      "href": "index.html"
    }
  }, [_c('img', {
    staticClass: "logo-default",
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "src": require("../../assets/kyelogo.png"),
      "alt": "logo",
      "width": "130px;"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu-toggler sidebar-toggler hide"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0c8ad18a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/header.vue
// module id = 412
// module chunks = 2